var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C12.5523 3 13 3.44772 13 4V12.7546L16.331 9.75671C16.7415 9.38725 17.3738 9.42053 17.7433 9.83104C18.1128 10.2415 18.0795 10.8738 17.669 11.2433L12.669 15.7433C12.2887 16.0856 11.7113 16.0856 11.331 15.7433L6.33104 11.2433C5.92053 10.8738 5.88725 10.2415 6.25671 9.83104C6.62616 9.42053 7.25845 9.38725 7.66896 9.75671L11 12.7546V4C11 3.44772 11.4477 3 12 3ZM4 15.5C4.55228 15.5 5 15.9477 5 16.5V18C5 18.5523 5.44772 19 6 19H18C18.5523 19 19 18.5523 19 18V16.5C19 15.9477 19.4477 15.5 20 15.5C20.5523 15.5 21 15.9477 21 16.5V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V16.5C3 15.9477 3.44772 15.5 4 15.5Z",
    fill: "#ADBFDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.94158df4ffd8a14ae6439598720a9c01.svg";
export { ForwardRef as ReactComponent };